/**
 * @flow
 * @relayHash 3d43c9d5cdffdafdb4b0707115a85775
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type categoryPage_category$ref = any;
export type srcCategoryQueryVariables = {|
  slug: string
|};
export type srcCategoryQueryResponse = {|
  +category: ?{|
    +$fragmentRefs: categoryPage_category$ref
  |}
|};
export type srcCategoryQuery = {|
  variables: srcCategoryQueryVariables,
  response: srcCategoryQueryResponse,
|};
*/


/*
query srcCategoryQuery(
  $slug: String!
) {
  category(slug: $slug) {
    ...categoryPage_category
  }
}

fragment categoryPage_category on Category {
  slug
  name
  color
  picture
  subcategories {
    slug
    name
    articles(first: 60) {
      slug
      title
      caption
      readingTime
      picture
      author {
        firstname
        lastname
      }
      category {
        slug
        name
      }
    }
  }
  seo {
    title
    description
  }
  social {
    twitter {
      type
      title
      image
      handle
      description
    }
    generic {
      title
      description
      image
    }
  }
  articles(first: 60) {
    slug
    title
    caption
    readingTime
    picture
    author {
      firstname
      lastname
    }
    category {
      slug
      name
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "slug",
    "type": "String!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "slug",
    "type": "String!"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "slug",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "picture",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "articles",
  "storageKey": "articles(first:60)",
  "args": [
    {
      "kind": "Literal",
      "name": "first",
      "value": 60,
      "type": "Int"
    }
  ],
  "concreteType": "Article",
  "plural": true,
  "selections": [
    v2,
    v5,
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "caption",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "readingTime",
      "args": null,
      "storageKey": null
    },
    v4,
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "author",
      "storageKey": null,
      "args": null,
      "concreteType": "Author",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "firstname",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "lastname",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "category",
      "storageKey": null,
      "args": null,
      "concreteType": "Category",
      "plural": false,
      "selections": [
        v2,
        v3
      ]
    }
  ]
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "description",
  "args": null,
  "storageKey": null
},
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "image",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "srcCategoryQuery",
  "id": null,
  "text": "query srcCategoryQuery(\n  $slug: String!\n) {\n  category(slug: $slug) {\n    ...categoryPage_category\n  }\n}\n\nfragment categoryPage_category on Category {\n  slug\n  name\n  color\n  picture\n  subcategories {\n    slug\n    name\n    articles(first: 60) {\n      slug\n      title\n      caption\n      readingTime\n      picture\n      author {\n        firstname\n        lastname\n      }\n      category {\n        slug\n        name\n      }\n    }\n  }\n  seo {\n    title\n    description\n  }\n  social {\n    twitter {\n      type\n      title\n      image\n      handle\n      description\n    }\n    generic {\n      title\n      description\n      image\n    }\n  }\n  articles(first: 60) {\n    slug\n    title\n    caption\n    readingTime\n    picture\n    author {\n      firstname\n      lastname\n    }\n    category {\n      slug\n      name\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "srcCategoryQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "category",
        "storageKey": null,
        "args": v1,
        "concreteType": "Category",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "categoryPage_category",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "srcCategoryQuery",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "category",
        "storageKey": null,
        "args": v1,
        "concreteType": "Category",
        "plural": false,
        "selections": [
          v2,
          v3,
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "color",
            "args": null,
            "storageKey": null
          },
          v4,
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "subcategories",
            "storageKey": null,
            "args": null,
            "concreteType": "Category",
            "plural": true,
            "selections": [
              v2,
              v3,
              v6
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "seo",
            "storageKey": null,
            "args": null,
            "concreteType": "SEO",
            "plural": false,
            "selections": [
              v5,
              v7
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "social",
            "storageKey": null,
            "args": null,
            "concreteType": "SocialMedia",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "twitter",
                "storageKey": null,
                "args": null,
                "concreteType": "TwtrSlices",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "type",
                    "args": null,
                    "storageKey": null
                  },
                  v5,
                  v8,
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "handle",
                    "args": null,
                    "storageKey": null
                  },
                  v7
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "generic",
                "storageKey": null,
                "args": null,
                "concreteType": "GenSocialSlices",
                "plural": true,
                "selections": [
                  v5,
                  v7,
                  v8
                ]
              }
            ]
          },
          v6
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '06d8c8682cf541dc5c9d9908fb275072';
module.exports = node;
